"use client";

import { GoogleOAuthProvider } from "@react-oauth/google";
import { GOOGLE_CLIENT_ID, isGoogleOAuthConfigured } from "@/constants";
import { useAuthInitialization } from "@/hooks";

function AuthInit({ children }: { children: React.ReactNode }) {
  useAuthInitialization();
  return <>{children}</>;
}

export function AuthBootstrap({ children }: { children: React.ReactNode }) {
  const tree = <AuthInit>{children}</AuthInit>;
  if (!isGoogleOAuthConfigured() || !GOOGLE_CLIENT_ID) return tree;
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>{tree}</GoogleOAuthProvider>
  );
}
